'use client';

import { CardsVerticalScrollProps } from './types';
import CardsVerticalScrollDesktop from './CardsVerticalScrollDesktop';
import CardsVerticalScrollMobile from './CardsVerticalScrollMobile';

const CardsVerticalScroll = (props: CardsVerticalScrollProps) => {
  return (
    <>
      {/* Mobile version - visible below sm breakpoint */}
      <div className="md:hidden">
        <CardsVerticalScrollMobile {...props} />
      </div>

      {/* Desktop version - visible at sm breakpoint and above */}
      <div className="hidden md:block">
        <CardsVerticalScrollDesktop {...props} />
      </div>
    </>
  );
};

export default CardsVerticalScroll;
